module.exports = __webpack_public_path__ + "assets/adf5891e5d522d2f5e1b5532a067ed2c.svg";